module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/extroversion/8324b1d77d4a459170c3ce58c31c2309.png";